import { Common } from '../common';
import {
  FilterOptions,
  ProvidersWithSupportedValues,
  SafeProviderWithPractices,
} from '../models/previsit/provider';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async getProvider(
    orgId: string,
    userId: string,
  ): Promise<SafeProviderWithPractices> {
    const url = this.common.constructPath(
      `/patient-previsit/organizations/${orgId}/providers/${userId}`,
    );
    const { provider } = await this.common.getJSON(url);
    return provider;
  }

  async findAllByOrganizationId(
    orgId: string,
    filterOptions: FilterOptions = {},
  ): Promise<ProvidersWithSupportedValues> {
    const url = this.common.constructPath(
      `/patient-previsit/organizations/${orgId}/providers`,
      filterOptions,
    );
    const allProviders = await this.common.getJSON(url);
    return allProviders;
  }

  async getProviderId(orgId: string, slug: string): Promise<string> {
    const url = this.common.constructPath(
      `/patient-previsit/organizations/${orgId}/providers/slug/${slug}`,
    );
    const { providerUserId } = await this.common.getJSON(url);
    return providerUserId;
  }
}
